// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"59791ccc","709":"32d5f22f"}[chunkId] + ".chunk.css";
};